export default __webpack_public_path__ + "static/media/icn-person-24px.d7d39a23.svg";